import React from "react";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";

import { translationService } from "../../services/translation/TranslationService";
import Language from "../../services/translation/language";
import { appSessionStorage } from "../../services/storage/SessionStorageService";

interface TermsAndConditionsProps {
  textKeyBeforeLinks?: string;
  textKeyAfterLinks?: string;
}

export const TermsAndConditions = observer((props: TermsAndConditionsProps) => {
  const pathAgb:string = translationService.language === Language.english
    ? appSessionStorage.getStorageItem("config-storage").agb && appSessionStorage.getStorageItem("config-storage").agb.english || "https://esic-sarida.cloud/en/general-terms-and-conditions/"
    : appSessionStorage.getStorageItem("config-storage").agb && appSessionStorage.getStorageItem("config-storage").agb.german || "https://esic-sarida.cloud/agb/";
  
    const pathImprint:string = translationService.language === Language.english
  ? appSessionStorage.getStorageItem("config-storage").imprint && appSessionStorage.getStorageItem("config-storage").imprint.english || "https://esic-sarida.cloud/en/imprint/"
  : appSessionStorage.getStorageItem("config-storage").imprint && appSessionStorage.getStorageItem("config-storage").imprint.german || "https://esic-sarida.cloud/impressum/";

  return (
    <div className="terms-and-conditions-container">
      {props.textKeyBeforeLinks ? translationService.translate(props.textKeyBeforeLinks) : ""}
      <Link
        to={{
          "pathname":pathAgb
        }
          }
        target="_blank"
      >
        {translationService.translate("general.terms-and-conditions")}
      </Link>
      <span> & </span>
      <Link
        to={{
          "pathname":pathImprint
        }
          }
        target="_blank"
      >
        {translationService.translate("general.privacy-policy")}
      </Link>
      {props.textKeyAfterLinks ? translationService.translate(props.textKeyAfterLinks) : ""}
    </div>
  );
});
